<template>
    <div>
        <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="containerForm" :refresh-key="refreshTabsKey" :set-api-data="setApiData" :show-expand="$route.name == 'auditEditor'" :has-import="true">
            <template v-slot:expand="{ item, refreshKey }">
                <component :is="container" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
            </template>
            <template v-slot:tabs>
                <v-row>
                    <v-col>
                        <v-btn v-if="!displaySold" color="tertiary" dark class="mr-2 float-right" @click="sell()">Sell Containers</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn-toggle v-model="selectedButton" mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                            <v-btn :value="0" ref="owned" @click="toggleSold(false)"> Owned </v-btn>
                            <v-btn :value="1" ref="sold" @click="toggleSold(true)"> Sold </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
            </template>
        </table-base>
        <sell-container-form v-if="sellContainers" :filter="sellContainerFilter" @input="onInput()" @cancel="cancel()" :key="sellContainerKey" />
    </div>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
            sellContainerForm: () => import('../forms/SellContainerForm')
        },
        data() {
            return {
                containerForm: () => import('../forms/ContainerForm'),
                container: () => import('../editViews/Container'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Container Number', value: 'containerNumber' },
                    { text: 'Current Volume In Litres', value: 'volumeInLitres' },
                    { text: 'Current Weight In Kilograms', value: 'WeightInKilograms' },
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Is Filled', value: 'isFilled' },
                    { text: 'Is Created By Packer', value: 'isCreatedByPacker' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "containerNumber", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'containers',
                editPageName: 'container',
                apiMethod: 'Containers',
                claimName: 'Containers',
                formTitle: 'Container',
                excelTitle: 'Containers',
                hasEditPage: true,
                sellContainers: false,
                sellContainerFilter: {},
                displaySold: false,
                refreshTabsKey: 0,
                selectedButton: 0,
                sellContainerKey: 0
            }
        },
        methods: {
            sell() {
                this.sellContainers = true;
                this.sellContainerFilter = { ...this.filter, isSold: false }
            },
            onInput() {
                this.dialog = false;
                this.refreshTabsKey++;
                this.sellContainerKey++;
                this.sellContainers = false;
                this.toggleSold(true);
                this.selectedButton = 1;
            },
            cancel() {
                this.sellContainerKey++;
                this.sellContainers = false;
            },
            setApiData(data) {
                this.$set(this.apiData, 'members', data.members);
                this.$set(this.apiData, 'facilities', data.facilities);
                this.$set(this.apiData, 'items', data.items.filter(i => this.displaySold == i.isSold));
            },
            toggleSold(displaySold) {
                this.displaySold = displaySold;
                this.refreshTabsKey = this.refreshTabsKey + 1;
            }
        },
        watch: {
            refreshKey() {
                this.refreshTabsKey++;
            }
        }
    };
</script>
